import React from "react";
import { CircleCheck } from "lucide-react";
import { useTranslation } from "components/translations/useTranslation";
import OneButtonModalFooter from "components/modals/OneButtonModalFooter";
import UserProfileTooltip from "components/tooltip/UserProfileTooltip.component";
import { ICON_SIZE } from "components/common/constants";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";
import { Assignment, Explanation } from "types/workflowDetailsWizard";
import { WorkflowDetailsUsersProps } from "types/modals";

const WorkflowDetailsUsers = ({
    more,
    closeModal,
    loopFocus,
    initialFocusRef,
}: WorkflowDetailsUsersProps): React.ReactElement => {
    const { translate } = useTranslation();
    const assignments = more?.assignments ?? [];
    // A user in completedAssignments acted on their line (approved); anyone else is still pending a decision.
    const approvedUserIds = new Set((more?.completedAssignments ?? []).map((a: Assignment) => a.userDTO.idUser));

    return (
        <>
            <div className="ga-modal__content">
                <ul className="px-0 mb-0">
                    {assignments.map((assignment: Assignment) => (
                        <li key={assignment.userDTO.idUser} className="py-3">
                            <UserProfileTooltip user={assignment.userDTO}>
                                {more?.isCompello && (approvedUserIds.has(assignment.userDTO.idUser) ?
                                    <span className="d-inline-flex align-items-center">
                                        {translate("taskDetail.actionTypes.APPROVED")}
                                        <CircleCheck size={ICON_SIZE.SMALL} className="ms-1"/></span> :
                                    <span>{translate("taskDetail.decisionPending")}</span>)}
                            </UserProfileTooltip>
                            {assignment.explanations?.map((explanation: Explanation, index: number) => (
                                <div key={`${explanation.action}-${index}`} className="mt-2 ga-text-helper">
                                    {explanation.action}
                                </div>
                            ))}
                        </li>
                    ))}
                </ul>
            </div>
            <OneButtonModalFooter
                tabIndex={MODAL_CONTENT_TAB_INDEX}
                enabled={true}
                callback={closeModal}
                text={translate("popUp.close")}
                loopFocus={loopFocus}
                buttonRef={initialFocusRef}
            />
        </>
    );
};

export default WorkflowDetailsUsers;
